import * as environments from 'src/environments.json';
import at from '../../shared/utils/at';

const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const USE_CASE_URL = 'payments';

const downloadPaymentListExcel = ({
  companyHeadquarterId,
  fromDate,
  toDate
}) => {
  const url = `${
    env.api.url
  }/${USE_CASE_URL}/download/excel?companyHeadquarterId=${companyHeadquarterId}&fromDate=${fromDate ||
    ''}&toDate=${toDate || ''}&t=${at(localStorage.accessToken)}`;

  window.location = url;
};

export default downloadPaymentListExcel;
